export var IngestionPipelineIssueSeverity;
(function (IngestionPipelineIssueSeverity) {
    IngestionPipelineIssueSeverity["INGESTION_PIPELINE_ISSUE_SEVERITY_DEGRADED"] = "DEGRADED";
    IngestionPipelineIssueSeverity["INGESTION_PIPELINE_ISSUE_SEVERITY_UNHEALTHY"] = "UNHEALTHY";
})(IngestionPipelineIssueSeverity || (IngestionPipelineIssueSeverity = {}));
